import { Vars } from '../model/vars';
import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ExecutingUnit } from '../entities/executingUnit';
import { FiscalYear } from '../entities/fiscalYear';
import { PayrollAmount } from '../entities/payroll-amount';
import { EmployeeType } from '../entities/employeeType';
import { ReportAlphabetical } from '../model/report-alphabetical';


interface ExtraSearchFields {
  object?: any;
  fiscalYear?: FiscalYear,
  executingUnit?: ExecutingUnit,
  employeeType?: EmployeeType
}

@Injectable()
export class ReportNepotismService extends BaseReportService<ReportAlphabetical> {

  public uri = '/api/reportNepotism/';

  constructor(injector: Injector) {
    super(injector);
  }

  buildSentence(entity?: ReportAlphabetical, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${extraSearchFields.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/report-nepotism.service.ts